import { Component, OnInit } from '@angular/core';
import { SocialService } from '../../../../../../../common/services/Social.service';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'settings-conversation-zalo-redirect',
  templateUrl: './zalo.component.html',
  styleUrls: ['./zalo.component.css'],
  providers: [SocialService],
})
export class ZaloRedirectComponent implements OnInit {
  constructor(
    private socialService: SocialService,
    private route: ActivatedRoute
  ) {
    let query = '';
    this.route.queryParams.subscribe((params: Params) => {
      let i = 0;
      for (const key in params) {
        if (i > 0) {
          query += `&${key}=${params[key]}`;
        } else {
          query += `?${key}=${params[key]}`;
        }
        i++;
      }
    });
    this.socialService.loginZaloSuccess(query).subscribe(result => {
      console.log(result);
      window.opener.postMessage('PopupClosed', '*');
    });
  }

  async ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/conversation/zalo/login_redirector/zalo.component.ts